import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccountAccessStore } from '../store/account-access.store';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Guard que protege las rutas de transferencia
 * Bloquea el acceso si la cuenta seleccionada tiene permisos de solo lectura
 */
export const canMakeTransfersGuard: CanActivateFn = (route, state) => {
  const accountAccessStore = inject(AccountAccessStore);
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);

  // Verificar si el usuario puede hacer transferencias
  if (!accountAccessStore.canMakeTransfers()) {
    // Mostrar mensaje de error
    const message = accountAccessStore.getAccessDeniedMessage();
    snackBar.open(message, 'Entendido', {
      duration: 5000,
      panelClass: ['mat-snack-error'],
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });

    // Redirigir al dashboard
    router.navigate(['/']);
    return false;
  }

  return true;
};
